import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { SpecraEyebrow, SpecraLink, SpecraText } from '@mono/ui-components/ensigns';
import { SpecraBreadcrumbs, SpecraPageHeader } from '@mono/ui-components/lieutenants';
import { Testids } from '@mono/ui-selectors';
import { renderRouterLink } from '../../../../lib/renderRouterLink';
import { registryHref } from '../../registryHref';
export function GovOrgHeader({ dossier: d, actions }) {
    const refs = (items)=>items.map((r, i)=>/*#__PURE__*/ _jsxs("span", {
                children: [
                    i > 0 && ', ',
                    /*#__PURE__*/ _jsx(SpecraLink, {
                        href: registryHref(r) ?? undefined,
                        renderLink: renderRouterLink,
                        children: r.name
                    })
                ]
            }, r.id));
    return /*#__PURE__*/ _jsxs("div", {
        className: "space-y-3",
        children: [
            /*#__PURE__*/ _jsx(SpecraBreadcrumbs, {
                label: "Parent organizations",
                "data-testid": Testids.registryGovOrg.parentCrumbs,
                renderLink: renderRouterLink,
                items: d.ancestors.map((a)=>({
                        id: a.id,
                        label: a.name,
                        href: registryHref(a) ?? undefined
                    }))
            }),
            d.publicParentClaims.map((p, i)=>/*#__PURE__*/ _jsx(SpecraText, {
                    as: "p",
                    size: "meta",
                    tone: "muted",
                    "data-testid": Testids.registryGovOrg.publicParent,
                    children: p.label
                }, `${p.parent?.id}-${i}`)),
            /*#__PURE__*/ _jsx(SpecraPageHeader, {
                titleSize: "home",
                eyebrow: /*#__PURE__*/ _jsxs(SpecraEyebrow, {
                    children: [
                        "Government org",
                        d.displayType ? ` · ${d.displayType.replace(/_/g, ' ').toLowerCase()}` : ''
                    ]
                }),
                title: d.name,
                description: /*#__PURE__*/ _jsxs(_Fragment, {
                    children: [
                        d.acronym,
                        d.buysFor.length > 0 && /*#__PURE__*/ _jsxs(_Fragment, {
                            children: [
                                d.acronym && ' · ',
                                "buys IT for ",
                                refs(d.buysFor)
                            ]
                        }),
                        d.vehiclesAwarded.length > 0 && /*#__PURE__*/ _jsxs(_Fragment, {
                            children: [
                                (d.acronym || d.buysFor.length > 0) && ' · ',
                                "awarded ",
                                refs(d.vehiclesAwarded)
                            ]
                        })
                    ]
                }),
                actions: actions
            })
        ]
    });
}
